<dx-button class="cancel-btn" [text]="translatedText" (onClick)="closeModal()" stylingMode="outlined" type="normal">
</dx-button>